import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	selector: 'rpshared-error-dialog',
	templateUrl: './error-dialog.component.html',
	styles: ['p { white-space: pre-line }'],
})
export class ErrorDialogComponent implements OnInit {
	message = 'An error occurred.';

	constructor(@Inject(MAT_DIALOG_DATA) private readonly data: string) {}

	ngOnInit() {
		this.message = this.data;
	}
}
